import React from 'react';

function ValueProposition() {
    const handleScroll = (e, targetId) => {
        e.preventDefault();
        const element = document.getElementById(targetId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section className="value-section">
            <div className="value-content">
                <h1 className="main-tagline">
                    <span className="highlight">One Partner</span>. Every System. <span className="highlight">Complete Control</span>.
                </h1>
                <p className="value-description">
                    <strong>You're paying Booking.com more than your entire housekeeping department.</strong> Your GM is on call at their kid's birth. Your Executive Housekeeper is reading audit scores at 10:30 PM after a 12-hour day. 47 unanswered reviews are costing you thousands in lost bookings.
                    <br /><br />
                    We're <strong>hospitality operators who learned to code</strong> not tech people who learned about hotels. We've lived the 10:30 PM audit meetings. <strong>Warp Mill</strong> is your single partner for customer care, OTA management, social media, recruiting, and development all coordinated by one team.
                </p>
                <div className="cta-group">
                    <a href="#services" className="cta-primary" onClick={(e) => handleScroll(e, 'services')}>
                        Explore the Full System
                    </a>
                    <a href="#demo" className="cta-secondary" onClick={(e) => handleScroll(e, 'demo')}>
                        See It In Action
                    </a>
                </div>
                <div className="trust-badges">
                    <div className="badge">
                        <div className="badge-number">$47M+</div>
                        <div className="badge-text">Revenue Managed</div>
                    </div>
                    <div className="badge">
                        <div className="badge-number">95%</div>
                        <div className="badge-text">24hr Review SLA</div>
                    </div>
                    <div className="badge">
                        <div className="badge-number">98%+</div>
                        <div className="badge-text">OTA Parity Uptime</div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ValueProposition;

